import { useState, useEffect } from "react"
import { useUpdateHepMutation, useDeleteHepMutation } from "./hepApiSlice"
import { useGetUsersQuery } from '../users/usersApiSlice'

import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTrashCan, faPrint, faFilePen, faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"
import { toast } from 'react-toastify'
import HepExerciseList from "./HepExerciseList"
import { fixDate, isMobileDevice } from "../../config/functions"

const EditHepForm = ({ hep, users, hep_id}) => {

    const { userId, isManager, isAdmin } = useAuth()

    const isMobile=isMobileDevice()

    // get user data for manager: start
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })
    let staffMembers=null
    if (isManager) {
        // get staff members, used for managers only
        staffMembers=user.staff

        // add manager id for current users
        staffMembers= [...staffMembers, userId]
    }
    // get user data for manager: end


    const [updateHep, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateHepMutation()

    const [deleteHep, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteHepMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState(hep.title)
    const [text, setText] = useState(hep.text)
    const [userID, setUserID] = useState(hep.user)
    
    // used to show/hide top part of the form
    const [isVisible, setIsVisible] = useState(true) 
    const [icon, setIcon] = useState(isVisible ? faArrowUp : faArrowDown )
    const [iconText, setIconText]=useState(isVisible ? 'Hide HEP Details' : 'Show HEP Details' )
    
    const toggleVisible = () => {
        setIsVisible(prev => !prev)
        if (isVisible) {
            setIcon(faArrowDown)
            setIconText('Show HEP Details')
        } else {
            setIcon(faArrowUp)
            setIconText('Hide HEP Details')
        }
    }   

    useEffect(() => {

        if (isSuccess) {
            setTitle('')
            setText('')
            setUserID('')
            toast.success("HEP was Updated");
            navigate('/dash/hep')
        }

        if (isDelSuccess) {
            setTitle('')
            setText('')
            setUserID('')
            toast.success("HEP was Deleted");
            navigate('/dash/hep')
        }

        if (isError) {
            toast.error(error?.data?.message);
        }

        if (isDelError) {
            toast.error(delerror?.data?.message);
        }

    }, [isSuccess, isDelSuccess, isError, isDelError, error, delerror, navigate])

    const onTitleChanged = e => setTitle(e.target.value)
    const onTextChanged = e => setText(e.target.value)
    const onUserIDChanged = e => setUserID(e.target.value)


    const canSave = [title, text, userId].every(Boolean) && !isLoading

    const onSaveHepClicked = async (e) => {
        if (canSave) {
            await updateHep({ id: hep.id, user: userID, title, text })            
        }
    }

    const onDeleteHepClicked = async () => {
        await deleteHep({ id: hep.id })
    }

    const onPrintHepClicked = async () => {
        if (isMobile) {
            navigate(`/portal/${hep_id}`)
        } else {
            navigate(`/dash/hep/print/${hep_id}`)
        }
    }

    
    const created = fixDate(hep.createdAt, 'm/d/y')
    const updated = fixDate(hep.updatedAt, 'm/d/y')


    let filteredIds=null
    if (isAdmin) {
        // show all Users
        filteredIds = [...users]
    } else if (isManager){
        //only show staff members
        filteredIds = users.filter(user_ID => staffMembers.includes(user_ID.id))
    } else {
        // only show HEPs for current user
        filteredIds = users.filter(user_ID => user.id === user_ID.id)
    }

    const options = filteredIds.map(user => {
        return (
            <option key={user.id} value={user.id}>
                {user.firstname} {user.lastname}
            </option >
        )
    })




    let deleteButton = null
    if (isManager || isAdmin) {
        deleteButton = (
            <span
                role="button"
                title="Delete"
                className="text-danger p-2 icon"
                onClick={onDeleteHepClicked}
            >
                Delete
                <FontAwesomeIcon icon={faTrashCan}  className="fa-icon"/>
            </span>
        )
    }

    const content = (
        <section id="main_content">
            <header>
                <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faFilePen} style={{fontSize:"30px", marginRight:"5px"}}/>Edit HEP #{hep.program}</h1>
            </header>
            <main>
                <form onSubmit={e => e.preventDefault()}>
                    {isVisible &&
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="hep-title">
                                Title:</label>
                            <input
                                className="form-control"
                                id="hep-title"
                                name="title"
                                type="text"
                                autoComplete="off"
                                value={title}
                                onChange={onTitleChanged}
                            />
                            <label className="form-label" htmlFor="hep-username">Therapist:</label>
                            <select
                                id="hep-username"
                                name="username"
                                className="form-select"
                                value={userID}
                                onChange={onUserIDChanged}
                            >
                                {options}
                            </select>
                            <p className="mt-5">
                                Created: {created}<br/>
                                Updated: {updated}
                            </p>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label" htmlFor="hep-text">
                                Instructions:</label>
                            <textarea
                                className="form-control"
                                id="hep-text"
                                rows="8"
                                name="text"
                                value={text}
                                onChange={onTextChanged}
                            />
                        </div>
                    </div>
                    }

                    <div className="row">
                        <div className="col-md-12 text-end">
                            <span
                                role="button"
                                title={iconText}
                                className="text-secondary p-2 icon"
                                onClick={toggleVisible}
                            >
                                <FontAwesomeIcon icon={icon} className="fa-icon"/>...
                            </span>
                            <span
                                role="button"
                                title="Print"
                                className="text-info p-2 icon"
                                onClick={onPrintHepClicked}
                            >
                                Share
                                <FontAwesomeIcon icon={faPrint} className="fa-icon"/>
                            </span>
                            <span
                                role="button"
                                title="Save"
                                className="text-success p-2 icon"
                                onClick={onSaveHepClicked}
                            >
                                Save
                                <FontAwesomeIcon icon={faSave}  className="fa-icon"/>
                            </span>
                            {deleteButton}
                        </div>
                    </div>
                    
                </form>
                <HepExerciseList hep_id={hep_id} program={hep.program}/>
            </main>
        </section>
    )

    return content
}

export default EditHepForm